import "url-search-params-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import routes from "./routes";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import "utils/i18n";
import "./assets/css/index.css";
import "moment/locale/ro";
import { AreasWrapper } from "./providers/AreasProvider";
import AuthApolloProvider from "apollo/AuthApolloProvider";
import AuthProvider from "providers/AuthenticationProvider";
import { getTenantId, getTenantUrlSufix, TenantProvider } from "providers/TenantProvider";
import GqlThemeProvider from "./providers/GqlThemeProvider";
import { THEME_QUERY, getTheme, defaultThemeCode } from "./utils/themes";
import { AppContextProvider } from "providers/AppContextProvider";
import { publicKeyword } from "features/common/constants";
import ValidateUserProvider from "providers/ValidateUserProvider";

ReactDOM.render(
  <AppContextProvider>
    <AreasWrapper>
      <TenantProvider>
        <AuthProvider>
          <AuthApolloProvider>
            <ValidateUserProvider>
              <GqlThemeProvider
                defaultTheme={getTheme(defaultThemeCode)}
                query={THEME_QUERY}
                options={{
                  variables: {
                    tenant: getTenantId(),
                    isPublic: window.location.pathname.includes(publicKeyword.publicPathName),
                  },
                }}
              >
                <BrowserRouter basename={getTenantUrlSufix()}>{routes}</BrowserRouter>
              </GqlThemeProvider>
            </ValidateUserProvider>
          </AuthApolloProvider>
        </AuthProvider>
      </TenantProvider>
    </AreasWrapper>
  </AppContextProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
